import yup from '@/lib/yupGenerator'

const schema = yup.object().shape({
  name: yup.string().required(),
  pharmacie_name: yup.string().required(),
  phone: yup.number().required(),
})

export default schema
